import toBase64 from "@/helpers/files/fileToBase64";
import formatBytes from "@/helpers/files/formatBytes";
import getSelectedFiles from "@/helpers/files/getSelectedFiles";
import getFileCategory from "@/helpers/files/getFileCategory";
import isImageFile from "@/helpers/files/isImageFile";
import isPDFFile from "@/helpers/files/isPDFFile";
import toFileState from "@/helpers/files/toFileState";

export default {
  toBase64,
  formatBytes,
  getSelectedFiles,
  getFileCategory,
  isImageFile,
  isPDFFile,
  toFileState,
};
